import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';

import Layout from './hoc/Layout/Layout';
import Kanban from './containers/Kanban/Kanban';
import NewResource from './containers/NewResource/NewResource';
import Account from './containers/Account/Account';
import Archived from './containers/Archived/Archived';
import TripTracking from './containers/TripTracking/TripTracking';
import TrackingPage from './containers/TrackingPage/TrackingPage';
import About from './containers/About/About';

class App extends Component {
  render() {
    return (
      <div>
        <Layout>
          <Switch>
            <Route path="/trip-tracking/tracking" component={TrackingPage} />
            <Route path="/new-request" component={NewResource} />
            <Route path="/trip-tracking" component={TripTracking} />
            <Route path="/account" component={Account} />
            <Route path="/archived" component={Archived} />
            <Route path="/about" component={About} />
            <Route path="/" component={Kanban} />
          </Switch>
        </Layout>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js